import { AWSVisitorIdClient } from '@amzn/aws-d2c-visitor-id-client';
import { updateCommon } from './dataLayer';
import { VisitorIdOptions } from '../types/types';
import { getD2CClientEnv } from '../utils/env-utils';
import { log } from '../utils/logger';

export class VisitorId {
  vidClient: AWSVisitorIdClient;
  private currentVal: string;
  private getVisitorTokenAndHandleCallback: VisitorIdOptions['getVisitorTokenAndHandleCallback'];

  constructor(opts: VisitorIdOptions) {
    this.currentVal = '';
    this.getVisitorTokenAndHandleCallback = opts.getVisitorTokenAndHandleCallback;

    this.vidClient = new AWSVisitorIdClient({
      cookieAllowed: opts.cookieAllowed,
      env: getD2CClientEnv(),
    });

    log('Visitor ID has been initialized, requesting visitor token');
    this.getVisitorTokenAndHandle();
  }

  /**
   * If the visitor permits functional cookies, requests a visitor token to set in the visitor's
   * browser and updates the data layer with the new token.
   */
  getVisitorTokenAndHandle(): void {
    const cookiesAllowed = this.vidClient.options.cookieAllowed;
    if (cookiesAllowed) {
      this.currentVal = this.vidClient.getExistingToken();

      this.vidClient.getVisitorToken({
        onSuccess: () => {
          this.updateTokenInDataLayer(this.vidClient.getExistingToken());
          this.getVisitorTokenAndHandleCallback();
        },
        onError: (e: Error) => {
          this.updateTokenInDataLayer(this.currentVal);
          console.error(`Error when attempting to get visitor token: ${e}`);
          this.getVisitorTokenAndHandleCallback();
        },
      });
    }
  }

  /**
   * Updates the Visitor ID Client's cookie consent setting
   * @param cookieAllowed - Determines if functional cookie permissions have been granted by the visitor
   */
  setCookieAllowed(cookieAllowed: boolean): void {
    this.vidClient.options.cookieAllowed = cookieAllowed;
  }

  /**
   * Updates the token value in the common data layer properties
   * @param token - The token that will be set in the data layer
   */
  updateTokenInDataLayer(token: string): void {
    updateCommon({
      d2cVisitorToken: token || '',
    });
  }
}
